var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2Nd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1956_8965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9398 37H3.39581V31.384L10.1638 24.52C12.5638 22.056 14.2278 20.168 15.1558 18.856C16.1158 17.544 16.5958 16.152 16.5958 14.68C16.5958 13.176 16.1958 12.12 15.3958 11.512C14.6278 10.904 13.5238 10.6 12.0838 10.6C9.93981 10.6 7.60381 10.792 5.07581 11.176L3.92381 11.32L3.58781 6.184C6.72381 5.224 9.97181 4.744 13.3318 4.744C20.0518 4.744 23.4118 7.768 23.4118 13.816C23.4118 16.184 22.8998 18.232 21.8758 19.96C20.8518 21.688 18.9958 23.784 16.3078 26.248L10.7878 31.24H23.9398V37ZM32.78 21H28.9208V6.6H32.7512V7.4064C34.0568 6.6384 35.2568 6.2544 36.3512 6.2544C38.2712 6.2544 39.596 6.8208 40.3256 7.9536C41.0552 9.0864 41.42 10.8336 41.42 13.1952V21H37.5608V13.3104C37.5608 12.0816 37.4168 11.1792 37.1288 10.6032C36.8408 10.008 36.2648 9.7104 35.4008 9.7104C34.6136 9.7104 33.8552 9.8448 33.1256 10.1136L32.78 10.2288V21ZM57.9435 0.839998V21H54.1131V20.3952C52.7691 21.0288 51.6075 21.3456 50.6283 21.3456C48.5355 21.3456 47.0763 20.7408 46.2507 19.5312C45.4251 18.3216 45.0123 16.4112 45.0123 13.8C45.0123 11.1696 45.5019 9.2592 46.4811 8.0688C47.4795 6.8592 48.9771 6.2544 50.9739 6.2544C51.5883 6.2544 52.4427 6.3504 53.5371 6.5424L54.0843 6.6576V0.839998H57.9435ZM53.6811 17.544L54.0843 17.4576V9.8832C53.0283 9.6912 52.0875 9.5952 51.2619 9.5952C49.7067 9.5952 48.9291 10.9776 48.9291 13.7424C48.9291 15.24 49.1019 16.3056 49.4475 16.9392C49.7931 17.5728 50.3595 17.8896 51.1467 17.8896C51.9531 17.8896 52.7979 17.7744 53.6811 17.544Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1956_8965",
    x: 0.395752,
    y: 0.839844,
    width: 60.5479,
    height: 42.1602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1956_8965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1956_8965",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Nd);
export default __webpack_public_path__ + "static/media/2nd.478f80721e70245ea850769abb93f3c4.svg";
export { ForwardRef as ReactComponent };